import { io } from "socket.io-client";
import { API_URL } from "constants";

class WebSocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

  connect() {
    if (this.socket?.connected) return;

    this.socket = io(API_URL, {
      path: "/socket.io/",
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      secure: true,
    });

    this.socket.on("connect", () => {
      console.log("Connected to websocket server");
    });

    this.socket.on("disconnect", () => {
      console.log("Disconnected from websocket server");
    });

    this.socket.on("error", (error) => {
      console.error("Websocket error:", error);
    });

    // Set up event listeners
    this.socket.on("video_generation_complete", (data) => {
      this.notifyListeners("video_generation_complete", data);
    });

    this.socket.on("video_progress", (data) => {
      this.notifyListeners("video_progress", data);
    });

    this.socket.on("video_processing_started", (data) => {
      this.notifyListeners("video_processing_started", data);
    });

    // Chat event handlers
    this.socket.on("chat_event", (data) => {
      this.notifyListeners("chat_event", data);
    });

    this.socket.on("chat_cleared", (data) => {
      this.notifyListeners("chat_cleared", data);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  joinProject(projectId) {
    if (!this.socket?.connected) {
      this.connect();
    }
    this.socket.emit("join_project", { project_id: projectId });
  }

  leaveProject(projectId) {
    if (this.socket?.connected) {
      this.socket.emit("leave_project", { project_id: projectId });
    }
  }

  addEventListener(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event).add(callback);
  }

  removeEventListener(event, callback) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).delete(callback);
    }
  }

  notifyListeners(event, data) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach((callback) => callback(data));
    }
  }
}

const websocketService = new WebSocketService();
export default websocketService;
